import { __awaiter, __generator } from "tslib";
import { getLaunchFunctions } from './getLaunchFileFunctions';
export var launchTemplate = function (app, templateUrl) { return __awaiter(void 0, void 0, void 0, function () {
    var launchTemplate;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getLaunchFunctions()];
            case 1:
                launchTemplate = (_a.sent()).launchTemplate;
                return [2 /*return*/, launchTemplate(app, templateUrl)];
        }
    });
}); };
//# sourceMappingURL=launchTemplate.js.map